import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberWithCommas',
  standalone: true,
})
export class NumberWithCommasPipe implements PipeTransform {

  transform(num?: number | string, decimal: number = 2): string {
    // if (!num) return '';
    if (!num) return '0.00';

    if (typeof num === "number") num = num.toFixed(decimal);

    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
